import FindADoctor from ".";

export default function FindADoctorExamples() {
  return <FindADoctor onBackButton={() => console.log("onBackButton")} />;
}
